@if (masterData) {
  <sis-map
    class="sis-map"
    [masterData]="masterData"
    [hoverDisabled]="true"
    [showStatus]="false"
    [editMode]="editMode"
    [enableAssetSidepane]="false"
    [allowElementSelection]="false"
  ></sis-map>
}
